import "./TheSpotlight.module.css";
import MainNavigation from "@/reusable_sections/Header";
import CinematicPresence from "./sections/CinematicPresence";
import TheShowreel from "./sections/TheShowreel";
import ArtistryAttributes from "./sections/ArtistryAttributes";
import CriticalAcclaim from "./sections/CriticalAcclaim";
import CareerMilestones from "./sections/CareerMilestones";
import SecureTheTalent from "./sections/SecureTheTalent";
import FooterArchive from "@/reusable_sections/Footer";
export default function TheSpotlightPage() {
  return <div>
      <MainNavigation />
      <CinematicPresence />
      <TheShowreel />
      <ArtistryAttributes />
      <CriticalAcclaim />
      <CareerMilestones />
      <SecureTheTalent />
      <FooterArchive />
    </div>;
}